import React from "react";
import { observer } from 'mobx-react';
import QuizObjectTableComponent from "./Table";

interface QuizObjectTablesContainerProps {
    focusField: Function;
    blurField: Function;
    quiz_object: any;
}

const QuizObjectTablesContainer = observer(({
    quiz_object
}: QuizObjectTablesContainerProps) => {
    let tables = quiz_object.tables;

    return (
        <div className="QuizObjectTables">
            {tables.map((table: any, i: number) => {
                return <QuizObjectTableComponent key={i} table={table} />;
            })}
            <br />
        </div>
    );
});

export default QuizObjectTablesContainer;
/* {tables.length > 0 ? <h3>Tables</h3> : <div></div>} */
